import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";
import { ProductVisibilityType } from "@omni/types/api/product/bff/shared/enums/productVisibilityType.enum";
import { Button } from "@omni/ui/components/Button/button.component";
import * as SessionStorage from "@omni/utils/sessionStorage.utils";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { StorageKeys } from "@/utils/enums";

type Props = {
    availableMethods: Array<DeliveryType>;
    deliveryType: DeliveryType;
    changeDeliveryType: (newDeliveryType: string) => void;
    isFree: boolean;
    productVisibilityType?: ProductVisibilityType;
    sku: string;
    isUpdatingCart: boolean;
};

const SwitchDelivery = ({
    availableMethods,
    deliveryType,
    changeDeliveryType,
    isFree,
    productVisibilityType,
    sku,
    isUpdatingCart
}: Props) => {
    const { t } = useGranite();
    const changedDeliveryMethod =
        deliveryType === DeliveryType.ClickAndCollect
            ? DeliveryType.HomeDelivery
            : DeliveryType.ClickAndCollect;

    const onClick = () => {
        changeDeliveryType(changedDeliveryMethod);
        SessionStorage.setItem(StorageKeys.DeliveryType, changedDeliveryMethod);
    };

    const isClickAndCollectAvailable = () => {
        return [
            ProductVisibilityType.Collect,
            ProductVisibilityType.DeliveryAndCollect,
            ProductVisibilityType.CollectAndExpressDelivery,
            ProductVisibilityType.DeliveryAndExpressDeliveryAndCollect
        ].some((v) => v === productVisibilityType);
    };

    const isHomeDeliveryAvailable = () => {
        return [
            ProductVisibilityType.Delivery,
            ProductVisibilityType.DeliveryAndCollect,
            ProductVisibilityType.DeliveryAndExpressDeliveryAndCollect
        ].some((v) => v === productVisibilityType);
    };

    const isVisible =
        deliveryType === DeliveryType.ClickAndCollect
            ? isHomeDeliveryAvailable()
            : isClickAndCollectAvailable();

    if (!isVisible || availableMethods?.length === 1 || isFree) {
        return null;
    }

    return (
        <Button
            type={"button"}
            test={`switchDelivery-button-${sku}`}
            color="link"
            className="ml-3"
            onClick={() => onClick()}
            disabled={isUpdatingCart}
        >
            <i className={"las la-exchange-alt mr-1"} />
            {t(
                `general.cart.item.deliveryMethod.change.${changedDeliveryMethod}`
            )}
        </Button>
    );
};

export default SwitchDelivery;
